export default __webpack_public_path__ + "static/media/next02.5fb7cca9.svg";